import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { GRADE_NUMERAL_BY_VALUE } from 'commons/constants';
import FabricAttributeTooltip from './FabricAttributeTooltip';
import cleaningCodeDescriptions from './cleaning-code-desc.json';
import FabricAdditionalAttributesTag from './FabricAdditionalAttributesTag';
const FabricAdditionalAttributes = t0 => {
  const $ = _c(32);
  const {
    selectedItemGroupMaterial: t1,
    selectedItemGroupCleaningCode: t2,
    isPetAndKidFriendly: t3,
    isSustainable: t4,
    selectedItemTier: t5,
    selectedItemGrade: t6,
    showCleaningToolTip: t7,
    isPantoneFabric: t8,
    materialComposition: t9
  } = t0;
  const selectedItemGroupMaterial = t1 === undefined ? "" : t1;
  const selectedItemGroupCleaningCode = t2 === undefined ? "" : t2;
  const isPetAndKidFriendly = t3 === undefined ? false : t3;
  const isSustainable = t4 === undefined ? false : t4;
  const selectedItemTier = t5 === undefined ? 0 : t5;
  const selectedItemGrade = t6 === undefined ? 0 : t6;
  const showCleaningToolTip = t7 === undefined ? true : t7;
  const isPantoneFabric = t8 === undefined ? false : t8;
  const materialComposition = t9 === undefined ? "" : t9;
  const cleaningCodeRef = useRef(null);
  const normalizedTier = Number(selectedItemTier) || 0;
  const normalizedGrade = Number(selectedItemGrade) || 0;
  const gradeDisplay = GRADE_NUMERAL_BY_VALUE[normalizedGrade] || normalizedGrade;
  let t10;
  try {
    let t11;
    if ($[0] !== selectedItemGroupMaterial) {
      t11 = JSON.parse(selectedItemGroupMaterial);
      $[0] = selectedItemGroupMaterial;
      $[1] = t11;
    } else {
      t11 = $[1];
    }
    t10 = t11;
  } catch {
    t10 = selectedItemGroupMaterial;
  }
  const materialGroupAttributes = t10;
  let t11;
  if ($[2] !== materialGroupAttributes) {
    t11 = Array.isArray(materialGroupAttributes) ? materialGroupAttributes : [materialGroupAttributes];
    $[2] = materialGroupAttributes;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const materialGroupAttributesArray = t11;
  let t12;
  if ($[4] !== isPetAndKidFriendly) {
    t12 = isPetAndKidFriendly ? <FabricAdditionalAttributesTag>Pet-Friendly</FabricAdditionalAttributesTag> : null;
    $[4] = isPetAndKidFriendly;
    $[5] = t12;
  } else {
    t12 = $[5];
  }
  let t13;
  if ($[6] !== isSustainable) {
    t13 = isSustainable ? <FabricAdditionalAttributesTag>Sustainable</FabricAdditionalAttributesTag> : null;
    $[6] = isSustainable;
    $[7] = t13;
  } else {
    t13 = $[7];
  }
  let t14;
  if ($[8] !== isPantoneFabric) {
    t14 = !!isPantoneFabric && <FabricAdditionalAttributesTag>Pantone</FabricAdditionalAttributesTag>;
    $[8] = isPantoneFabric;
    $[9] = t14;
  } else {
    t14 = $[9];
  }
  let t15;
  if ($[10] !== materialGroupAttributesArray) {
    t15 = materialGroupAttributesArray.filter(_temp).map(_temp2);
    $[10] = materialGroupAttributesArray;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  let t16;
  if ($[12] !== normalizedTier) {
    t16 = normalizedTier > 0 ? <FabricAdditionalAttributesTag>{`Tier ${normalizedTier}  `}</FabricAdditionalAttributesTag> : null;
    $[12] = normalizedTier;
    $[13] = t16;
  } else {
    t16 = $[13];
  }
  let t17;
  if ($[14] !== gradeDisplay || $[15] !== normalizedGrade || $[16] !== normalizedTier) {
    t17 = normalizedTier <= 0 && normalizedGrade > 0 ? <FabricAdditionalAttributesTag>{`Grade ${gradeDisplay}  `}</FabricAdditionalAttributesTag> : null;
    $[14] = gradeDisplay;
    $[15] = normalizedGrade;
    $[16] = normalizedTier;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== materialComposition) {
    t18 = materialComposition?.trim() ? <FabricAdditionalAttributesTag>{materialComposition.trim()}</FabricAdditionalAttributesTag> : null;
    $[18] = materialComposition;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] !== selectedItemGroupCleaningCode || $[21] !== showCleaningToolTip) {
    t19 = selectedItemGroupCleaningCode && cleaningCodeDescriptions[selectedItemGroupCleaningCode] ? <FabricAdditionalAttributesTag isCleaningCode={true} ref={cleaningCodeRef}>{`Cleaning Code ${selectedItemGroupCleaningCode}`}{showCleaningToolTip ? <span className="mt-0 mx-0"><FabricAttributeTooltip title={cleaningCodeDescriptions[selectedItemGroupCleaningCode].title} description={cleaningCodeDescriptions[selectedItemGroupCleaningCode].description} parentRef={cleaningCodeRef} /></span> : null}</FabricAdditionalAttributesTag> : null;
    $[20] = selectedItemGroupCleaningCode;
    $[21] = showCleaningToolTip;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t16 || $[28] !== t17 || $[29] !== t18 || $[30] !== t19) {
    t20 = <div className="w-full flex flex-row items-stretch flex-wrap">{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  return t20;
};
FabricAdditionalAttributes.propTypes = {
  selectedItemGroupMaterial: PropTypes.string,
  selectedItemGroupCleaningCode: PropTypes.string,
  isPetAndKidFriendly: PropTypes.bool,
  isSustainable: PropTypes.bool,
  selectedItemTier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedItemGrade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showCleaningToolTip: PropTypes.bool,
  isPantoneFabric: PropTypes.bool,
  materialComposition: PropTypes.string
};
export default FabricAdditionalAttributes;
function _temp(attribute) {
  return attribute;
}
function _temp2(attribute_0) {
  return <FabricAdditionalAttributesTag key={attribute_0}>{attribute_0 === "greenguard" ? "GREENGUARD gold" : attribute_0}</FabricAdditionalAttributesTag>;
}